import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import store from '@/store'
import router from '@/router'
import CodemaoSDK from '@/utils/iris'
import '@/assets/styles/index.styl'
// pwa 使用
// import './registerServiceWorker'
import '@/utils/extend'
import '@/utils/message'
import '@/utils/filters'
import caReport from '@/utils/report'
import { Collapse, CollapseItem } from 'element-ui'
import ViserVue from 'viser-vue'
import VueXss from 'vue-xss'
import options from '@/utils/xss'
import Vconsole from 'vconsole'

Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(ViserVue)

sync(store, router)
Vue.use(VueXss, options)

Vue.use(CodemaoSDK)
Vue.use(caReport)

// 给每个路由设置页面title
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable no-new */
  new Vconsole()
}

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    // NOTE: 这里告知puppeteer页面完毕，用于预渲染.
    console.log('prerender event')
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
